import React, { FC } from 'react';
import { LoadingDots } from '../../../common/loading_dots';
import { IPortalPropertyPhotoAsset } from '../../../../interfaces/asset';
import { useSessionState } from '../../../../hooks/use_session_state';
import { PropertyPhotoPanel } from '../components/property_photo_panel';
import { useGetOrgPropertyPhotos } from '../hooks/useGetOrgPropertyPhotos';
import { useGetPropertiesPhotos } from '../hooks/useGetPropertiesPhotos';
import { usePhotoFilters } from '../../../../pages/property_media/property-photos/property_photos_context';
import { SessionType } from '../../../../interfaces/session';
import { StarringInstructions } from '../components/starring_instructions';

interface IOrgPhotosProps {
    orgNHID: number;
    onPropertySelected: (nhID: number) => void;
}

const OrganizationPropertyPhotos: FC<IOrgPhotosProps> = ({
  orgNHID,
  onPropertySelected,
}) => {
  const { hasNonPublishedPhotosFilter, profileCompletenessFilterValue } =
    usePhotoFilters();
  const { data = [], isLoading } = useGetOrgPropertyPhotos(orgNHID, {
    HasNonPublishedPhotos: hasNonPublishedPhotosFilter,
    profileCompletenessFilterValue,
  });

  return (
    <>
      <LoadingDots show={isLoading} />
      {data?.map((property: IPortalPropertyPhotoAsset) => (
        <PropertyPhotoPanel
          key={property.Property.NHID}
          property={property}
          onPanelSelected={onPropertySelected}
        />
      ))}
    </>
  );
};


interface IMultiPhotosProps {
    nhIDs: number[];
    onPropertySelected: (nhID: number) => void;
}

const MultiPropertyPhotos: FC<IMultiPhotosProps> = ({
  nhIDs,
  onPropertySelected,
}) => {
  const { hasNonPublishedPhotosFilter, profileCompletenessFilterValue } =
    usePhotoFilters();

  const { data = [], isLoading } = useGetPropertiesPhotos(nhIDs, {
    HasNonPublishedPhotos: hasNonPublishedPhotosFilter,
    profileCompletenessFilterValue,
  });

  return (
    <>
      <LoadingDots show={isLoading} />
      {data?.map((property) => (
        <PropertyPhotoPanel
          key={property.Property.NHID}
          property={property}
          onPanelSelected={onPropertySelected}
        />
      ))}
    </>
  );
};


interface IProps {
    handleSelectedNHID: (NHID: number | null) => void;
  }

const MultiOrOrgPropertyPhotos: FC<IProps> = ({ handleSelectedNHID }) => {
  const {
    Org,
    Properties,
    Session: { SessionType: sessionType },
  } = useSessionState();

  return (
    <>
      <div className="grid gap-3 sm:gap-5 md:gap-6 2xl:gap-7">
        <StarringInstructions />
        {sessionType === SessionType.SessionTypeOrg ? (
          <OrganizationPropertyPhotos
            orgNHID={Org.NHID}
            onPropertySelected={handleSelectedNHID}
          />
        ) : (
          <MultiPropertyPhotos
            nhIDs={Properties.map((p) => p.NHID)}
            onPropertySelected={handleSelectedNHID}
          />
        )}
      </div>
    </>
  );
};

export default MultiOrOrgPropertyPhotos;
